const helpers = {};

helpers.notify = (
  notify,
  options = {
    title: 'Whoops 😟',
    text: 'Something went wrong',
    timer: 2000,
    icon: 'error',
  }
) =>
  notify.fire({
    toast: true,
    position: 'top-right',
    ...options,
  });

export default helpers;
